import { Layout, RouteColor as RouteColorComponent } from "components"
export const RouteColor = () => {
 return (
  <Layout>
   <RouteColorComponent />
  </Layout>
 )
}
